module.exports = __webpack_public_path__ + "static/media/ff.55315615.jpg";